angular.module('controllers').controller('packagingController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', 'Crud',
	function ($scope, $rootScope, $controller, $route, $routeParams, $location, Crud) {
		$rootScope.path = '/packaging';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'packaging';
		$scope.pathTemplate = 'food/packaging';
		$scope.title = 'Ambalaje';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'packaging_name';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'packaging_name':{'label':'Denumire ambalaj', 'filter':1, 'filterType':'input'},
            'packaging_price':{'label':'Pret ambalaj', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals = [];
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'packaging_name';


	}]
);
